import PageContainer from "../../Layout/Containers/PageContainer";
import Cabil2Contain from "../../Component/Cabil2";

const Cabil2 = () => {
  return (
    <PageContainer
      // breadcrumbs={<Breadcrumbs parent="Form" title="Form" />}
    >
      {/* <DefaultContain /> */}
      <Cabil2Contain />
    </PageContainer>
  );
};

export default Cabil2;
